export default "__VITE_ASSET__RdUDfm8_NijmX6SuNoEgmw__"